import { ConsumerAddress, Country } from '@afterpaytouch/portal-api'

export const convertConsumerAddress = (address: ConsumerAddress): string => {
  return `${address?.address1} ${address?.address2 ?? ''}, ${address?.suburb}, ${address?.state}, ${address?.postcode}`
}

export const getCountryCodeFromLocale = (locale): Country => (locale?.split('-')[1]?.toUpperCase() as Country) ?? Country.AU
